import { spawn } from 'redux-saga/effects';

import bandwidthSagas from './bandwidth/bandwidthSagas';

export default function* monitoringSagas() {
	yield spawn(bandwidthSagas);
}
